import styled, { css } from "styled-components";
import { IQuickButtonsProps } from "./interfaces";

export const StyledQuickButtons = styled.div<IQuickButtonsProps>`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;

    opacity: 0;

    display: flex;
    align-items: center;
    justify-content: center;

    transition: 300ms;

    [class^="i-"] {
        color: ${p => p.theme.c.whiteOnActive};
        transition: 300ms;
        display: block;
        font-size: 60px;
        ${p =>
            p.tiny
                ? css`
                      font-size: 36px;
                  `
                : undefined}
    }

    .i-browse {
        font-size: 56px;
    }

    a {
        margin: 12px;
        cursor: pointer;
        &:hover {
            [class^="i-"] {
                transform: scale(1.24);
            }
        }
    }

    &.Show {
        opacity: 1;
        background-color: ${p => p.theme.c.blackShadow35};
    }

    .QuickButtonDisabled {
        pointer-events: none;
        opacity: 0.6;
    }
    ${p => p.tiny
        ? css`
            border-radius: 6px;
        `
        : undefined}
    ${p =>
        p.tinyMobile
            ? css`
                  opacity: 0 !important;
                  > div {
                      position: absolute;
                      top: 0;
                      right: 0;
                      left: 0;
                      bottom: 0;

                      a {
                          position: inherit;
                          top: 0;
                          right: 0;
                          left: 0;
                          bottom: 0;
                          margin: 0;
                      }
                  }
              `
            : undefined}
`;


export const ContextWrapper = styled.div`
    position: relative;
`;